<template>
  <div class="Tabs">
    <el-tabs v-model="activeValue" stretch @tab-click="tabClick"> 
      <el-tab-pane v-for="tab in tabsData" :key="tab.name" :label="tab.label" :name="tab.name">
        <span slot="label" class="tab-label">
          <div class="counts" v-if="isData">{{ tab.counts }}</div>
          <div class="label">{{ tab.label }}</div>
        </span>
        <slot :name="tab.name"></slot>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  data() {
    return {
      label: "",
      activeValue: this.active
    }
  },
  props: {
    active: {
      type: String
    },
    tabsData: {
      type: Array,
    }
  },
  methods: {
    tabClick() {
      this.$emit('tabClick', this.activeValue)
    }
  },
  computed: {
    isData() {
      return Object.prototype.hasOwnProperty.call(this.tabsData[0], "counts")
    }
  },
  watch: {
    active(updateValue) {
      this.activeValue = updateValue;
    }
  },
}
</script>

<style scoped>

</style>